import script from "./purPage.vue?vue&type=script&setup=true&lang=js"
export * from "./purPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__